import * as React from 'react';

interface GenResetPercentageCircleProps {
  percentage: number
  percentageOfRecommendedTime?: number
}

export default function GenResetPercentageCircle(props: GenResetPercentageCircleProps): React.JSX.Element {
  const {
    percentage,
    percentageOfRecommendedTime,
  } = props;

  if (percentage >= 100.0) {
    if (percentageOfRecommendedTime === undefined) {
      return <div className="aq-info-bubble-without-img-wrapper center-content">
              <span className="tooltip-box xsmall after-75 above-75">
                Completed
              </span>
              <div className="reset_progress_icon progress-done">
              </div>
            </div>;
    } else {
      return percentageOfRecommendedTime > 25
        ? <div className="aq-info-bubble-without-img-wrapper center-content">
            <span className="tooltip-box xsmall after-75 above-75">
              Completed
            </span>
            <div className="reset_progress_icon progress-done">
            </div>
          </div>
        : <div className="aq-info-bubble-without-img-wrapper center-content">
            <span className="tooltip-box xsmall after-75 above-75">
              Low Time (Completed in under 25% of recommended time)
            </span>
            <div className="reset_progress_icon low-time">
            </div>
          </div>;
    }
  } else if (percentage <= 0.0) {
    return <div className="aq-info-bubble-without-img-wrapper center-content">
            <span className="tooltip-box xsmall after-75 above-75">
              Not Started
            </span>
            <div className="reset_progress_icon mod_map_icon">
            </div>
          </div>;
  } else {
    return <div className='aq-info-bubble-without-img-wrapper center-content'>
            <span className="tooltip-box xsmall after-75 above-75">
              Partially Completed
            </span>
            <div className="reset_progress_icon progress-percent">
              { Math.round(percentage) }<span>%</span>
            </div>
          </div>;
  }
}
